import { ProductPage } from "../../productPage/ProductPage";

import { useFetch } from '../../../utils/functions';

export const Salads = ({
    isAuthorized,
    fetchProducts,
    addProductInCart,
    deletePurchasedProduct,
    cartList}) => {
    const address = 'salads';
    const { isLoading, products } = useFetch(address);

    fetchProducts(products);

    return (
        <div>
            <ProductPage products={products}
                        isLoading={isLoading}
                        isAuthorized={isAuthorized} 
                        address={address}
                        addProductInCart={addProductInCart}
                        deletePurchasedProduct={deletePurchasedProduct}
                        cartList={cartList}/>
        </div>
    )
};